import { setHours, setMinutes, setSeconds } from 'date-fns';

const setTimePerSpecificTime = function (date, time) {
  const [hourToBeSetted, minuteToBeSetted] = String(time).split(':');

  return setHours(setMinutes(setSeconds(date, 0), minuteToBeSetted), hourToBeSetted);
};

export default setTimePerSpecificTime;
